import React from "react";
import { Link } from "react-router-dom";
import { Routes } from "../App";
import WalletCard from "../components/wallet/WalletCard";
import WalletPreview from "../assets/wallet_preview.svg";
import WalletTexts from "../assets/wallet_texts.svg";
import WalletActivity from "../assets/wallet_activity.svg";
import SharePreview from "../assets/share_preview.svg";
import "../../src/components.css";
import { WhiteCard } from "../components/common";

const HomePage = () => {
  return (
    <div className="">
      <div
        className="pb-0"
        style={{
          backgroundImage: "linear-gradient(165deg, #3C95DA, #8829E0)",
        }}
      >
        <div className="container pt-10 mx-auto px-4">
          <div className="w-full flex flex-row items-center justify-between">
            <div className=" items-center  rounded-lg px-5 py-2 ">
              <Link to="/">
                <Logo dark={true} />
              </Link>
            </div>
            {/* <div className="w-full flex items-center hover:text-white justify-end text-lg font-semibold">
              <Link to={Routes.WALLET}>Wallet</Link>
            </div> */}
          </div>
          <div className="flex items-end  z-10">
            <div
              id="get-notified"
              className="w-full mt-20 flex flex-col items-start"
            >
              {/* left banner text*/}
              <div>
                <p className="font-black text-5xl text-black">
                  Build your <u>own</u> token
                </p>
                <p className="font-black text-4xl text-black mt-12">
                  Simplified asset creation for <u>everyone</u>
                </p>
                <Link to={Routes.STUDIO}>
                  <button className="studioBtn mt-12 mb-12 bg-black shadow-lg rounded-lg px-16 py-4 text-white text-2xl font-semibold transform motion-safe:hover:scale-125">
                    Studio
                  </button>
                </Link>
                <Link to={Routes.WALLET}>
                  <button className="sm:ml-12 sm:mt-12 mb-12  border-2 border-black shadow-lg rounded-lg px-16 py-4 text-black hover:bg-gray-50  text-2xl font-semibold z-10 homeButton">
                    Wallet
                  </button>
                </Link>
              </div>
            </div>
            <div className="z-10 hidden lg:block -mb-32">
              <div className="pl-36 pb-12">
                <TokodotScattered />
              </div>
              <TokoBits />
            </div>
          </div>
        </div>
        <div className="mt-20 mb-0 pb-0 z-0 hidden lg:block">
          <TokodotFlow />
        </div>
      </div>
      {/* Wallet banner */}
      <div
        className=""
        style={{
          backgroundImage: "linear-gradient(165deg, #3C95DA, #8829E0 )",
        }}
      >
        <div className="container mx-auto px-4 pb-6">
          <p className="pt-12 mb-12 text-3xl font-black text-white">
            Online wallet to get you started
          </p>
          <div className="flex flex-col-reverse lg:flex-row items-center justify-around">
            {/* Wallet feature list */}
            <img src={WalletTexts} className="w-96" />
            {/* <div
              className="mx-10 max-w-lg text-2xl font-bold mb-20 p-10 rounded-lg"
              style={{
                backgroundImage: "linear-gradient(165deg, #C8B4F2, #B1D5F0 )",
              }}
            >
              <ul>
                <li>
                  Manage your Algorand accounts through our secure online
                  wallet!
                </li>
                <li className="mt-12">
                  Create your own tokens and send it to your friends!
                </li>
                <li className="mt-12">
                  Gift Algorand to your friend's wallets by creating drops!
                </li>
              </ul>
            </div> */}
            {/* Wallet preview*/}
            <div className="p-12">
              <img src={WalletPreview} className="w-96" />
            </div>
          </div>
        </div>
        {/* <div className="mt-12"></div> */}
      </div>
      <div
        className="pb-12"
        style={{
          backgroundImage: "linear-gradient(165deg, #0F8DE7, #6900CA )",
        }}
      >
        <div className="container mx-auto px-4">
          <p className="pt-12 text-3xl font-black text-white">
            View all activity for a token
          </p>
          <div className="flex flex-col lg:flex-row items-center justify-around">
            {/* Wallet feature list */}
            <div>
              <ul className="space-y-4 text-white font-semibold text-xl list-disc list-inside my-6">
                <li>View recent activity for your wallet</li>
                <li>View transactions made by a account</li>
                <li>View transactions for a token</li>
              </ul>
            </div>
            <img src={WalletActivity} className="w-196" />
          </div>
          <p className="pt-12 text-3xl font-black text-white">
            Instantly share tokens you create
          </p>
          <div className="flex flex-col lg:flex-row items-center justify-around">
            {/* Wallet feature list */}
            <div>
              <ul className="space-y-4 text-white font-semibold text-xl list-disc list-inside my-6">
                <li>Invite new friends to Algorand</li>
                <li>
                  Create a drop wallet with certain amount of ALGO attached to
                  it
                </li>
                <li>
                  Attach a token to the drop wallet and create a shareable link
                </li>
              </ul>
            </div>
            <img src={SharePreview} className="w-96" />
          </div>
        </div>
      </div>
      <div className="bg-tokodot-dark-secondary z-10">
        <div className="container mx-auto px-4 py-6">
          <div className="flex items-center justify-between font-medium">
            <div className="text-tokodot-gray">© 2021 Tokodot</div>
            <div className="flex text-tokodot-gray ">
              <a
                rel="noreferrer"
                target="_blank"
                href="https://twitter.com/tokodotio"
              >
                Twitter
              </a>
             { /*<a className="ml-4">Discord</a>*/}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const TokoBits = () => (
  <svg
    width="504"
    height="188"
    viewBox="0 0 504 188"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0)" filter="url(#filter0_d)">
      <path
        d="M168.5 106.168C170.564 109.247 171.212 113.559 170.059 117.39C168.879 121.235 165.877 124.591 162.198 126.292C158.493 128.007 154.091 128.059 149.651 126.969C145.231 125.885 140.78 123.638 140.743 120.643C140.686 117.64 145.057 113.916 146.803 109.542C148.535 105.141 147.643 100.09 149.348 98.2785C151.026 96.48 155.274 97.9341 159.121 99.5676C162.982 101.228 166.442 103.068 168.5 106.168Z"
        fill="#9A93FF"
      />
      <path
        d="M155.358 132.069C157.67 132.485 160.082 130.907 160.555 128.459C160.955 126.063 159.247 123.741 156.935 123.325C154.497 122.885 152.148 124.475 151.749 126.871C151.275 129.319 152.92 131.629 155.358 132.069Z"
        fill="white"
      />
    </g>
    <g clip-path="url(#clip1)">
      <g filter="url(#filter1_d)">
        <path
          d="M266.322 149.676C270.482 153.186 275.76 155.396 277.45 159.088C279.14 162.78 277.242 167.98 273.888 170.996C270.56 174.038 265.776 174.896 261.2 176.768C256.624 178.614 252.256 181.474 248.148 181.058C244.066 180.642 240.244 176.976 238.476 172.712C236.734 168.448 237.046 163.586 237.956 158.88C238.866 154.2 240.374 149.676 243.468 145.984C246.588 142.266 251.294 139.38 255.194 140.368C259.068 141.33 262.162 146.166 266.322 149.676Z"
          fill="#9A93FF"
        />
      </g>
      <g filter="url(#filter2_d)">
        <path
          d="M262.701 161.802H258.482V155.922H249.661V161.802H246.529V168.194H249.661V179.284C249.597 184.43 252.777 187.035 258.866 186.699C260.863 186.587 262.35 186.172 263.149 185.932L261.87 179.732C261.535 179.812 260.672 179.988 260.144 179.988C258.994 179.988 258.482 179.476 258.482 178.453V168.194H262.701V161.802Z"
          fill="white"
        />
      </g>
    </g>
    <g clip-path="url(#clip2)">
      <g filter="url(#filter3_d)">
        <path
          d="M36.322 133.676C40.482 137.186 45.76 139.396 47.45 143.088C49.14 146.78 47.242 151.98 43.888 154.996C40.56 158.038 35.776 158.896 31.2 160.768C26.624 162.614 22.256 165.474 18.148 165.058C14.066 164.642 10.244 160.976 8.476 156.712C6.734 152.448 7.046 147.586 7.956 142.88C8.866 138.2 10.374 133.676 13.468 129.984C16.588 126.266 21.294 123.38 25.194 124.368C29.068 125.33 32.162 130.166 36.322 133.676Z"
          fill="#9A93FF"
        />
      </g>
      <g filter="url(#filter4_d)">
        <path
          d="M24.6506 167.249C27.3352 167.249 29.1747 165.807 29.9702 163.868H30.1193V167H36.9304V141.545H30.0696V151.24H29.9702C29.2244 149.301 27.4347 147.661 24.6009 147.661C20.8224 147.661 17.1435 150.544 17.1435 157.455C17.1435 164.067 20.5739 167.249 24.6506 167.249ZM27.1861 161.979C25.2969 161.979 24.2031 160.288 24.2031 157.455C24.2031 154.621 25.2969 152.93 27.1861 152.93C29.0753 152.93 30.2188 154.621 30.2188 157.455C30.2188 160.239 29.0753 161.979 27.1861 161.979Z"
          fill="white"
        />
      </g>
    </g>
    <g filter="url(#filter5_d)">
      <path
        d="M158.496 9.07743C161.526 11.5074 163.146 15.7374 162.996 19.5774C162.816 23.4474 160.866 26.8974 158.136 28.3674C155.436 29.8074 151.986 29.2974 149.616 28.9374C147.276 28.5774 145.986 28.4274 141.606 29.8374C137.196 31.2474 129.726 34.2474 128.286 33.0774C126.816 31.9374 131.406 26.6574 133.026 21.4074C134.646 16.1874 133.296 11.0274 135.066 8.35743C136.806 5.68743 141.666 5.53743 146.316 5.77743C150.996 6.01743 155.436 6.61743 158.496 9.07743Z"
        fill="#9A93FF"
      />
      <path
        d="M147.589 45.2534C155.453 46.6714 161.015 42.4784 162.354 35.0555C163.692 27.6326 159.945 21.7607 152.082 20.3427C144.218 18.9247 138.656 23.1178 137.317 30.5407C135.979 37.9635 139.726 43.8354 147.589 45.2534ZM148.809 38.8484C146.482 38.4287 145.515 35.8673 146.198 32.0772C146.882 28.2871 148.683 26.2249 151.01 26.6446C153.212 27.0417 154.179 29.603 153.495 33.3931C152.812 37.1832 151.011 39.2454 148.809 38.8484Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter6_d)">
      <path
        d="M405.496 108.077C408.526 110.507 410.146 114.737 409.996 118.577C409.816 122.447 407.866 125.897 405.136 127.367C402.436 128.807 398.986 128.297 396.616 127.937C394.276 127.577 392.986 127.427 388.606 128.837C384.196 130.247 376.726 133.247 375.286 132.077C373.816 130.937 378.406 125.657 380.026 120.407C381.646 115.187 380.296 110.027 382.066 107.357C383.806 104.687 388.666 104.537 393.316 104.777C397.996 105.017 402.436 105.617 405.496 108.077Z"
        fill="#9A93FF"
      />
      <path
        d="M394.589 144.253C402.453 145.671 408.015 141.478 409.354 134.055C410.692 126.633 406.945 120.761 399.082 119.343C391.218 117.925 385.656 122.118 384.317 129.541C382.979 136.964 386.726 142.835 394.589 144.253ZM395.809 137.848C393.482 137.429 392.515 134.867 393.198 131.077C393.882 127.287 395.683 125.225 398.01 125.645C400.212 126.042 401.179 128.603 400.495 132.393C399.812 136.183 398.011 138.245 395.809 137.848Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter7_d)">
      <path
        d="M329.789 48.2467C330.56 51.2094 328.846 55.5816 329.332 58.4293C329.817 61.277 332.473 62.6001 333.501 64.4986C334.529 66.4258 333.901 68.9283 332.244 70.1652C330.588 71.3733 327.904 71.3157 324.934 73.7607C321.993 76.1769 318.766 81.1244 317.767 80.0601C316.796 79.0246 318.053 71.9773 314.969 68.5831C311.885 65.1889 304.489 65.4766 300.891 63.0891C297.264 60.7017 297.436 55.6679 299.292 51.3245C301.148 46.981 304.717 43.3567 308.858 41.9473C313.027 40.5378 317.796 41.372 321.793 42.5513C325.791 43.7306 329.018 45.2839 329.789 48.2467Z"
        fill="#9A93FF"
      />
      <path
        d="M316.92 85.4939L325.461 83.2877L323.719 76.5418L324.583 74.5855L331.588 81.7051L341.367 79.1792L329.593 67.9768L334.98 55.4777L325.387 57.9556L321.694 67.4261L321.385 67.506L317.276 51.6005L308.735 53.8067L316.92 85.4939Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter8_d)">
      <path
        d="M484.285 110.446C480.43 111.73 475.685 111.159 471.973 108.824C468.255 106.457 465.583 102.308 464.857 97.9257C464.125 93.5111 465.352 88.8448 467.798 84.4711C470.231 80.1168 473.901 76.0684 477.077 76.9023C480.266 77.7168 482.927 83.4197 487.04 86.5385C491.186 89.6512 496.782 90.1799 498.2 92.5091C499.612 94.8057 496.838 98.8703 493.991 102.46C491.112 106.055 488.16 109.175 484.285 110.446Z"
        fill="#9A93FF"
      />
    </g>
    <g filter="url(#filter9_d)">
      <path
        d="M477.528 98.4714C478.594 101.141 479.294 109.494 472.386 113.324M485.574 96.3006C485.996 99.1434 489.592 106.715 497.489 106.551"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="square"
      />
    </g>
    <g filter="url(#filter10_d)">
      <line
        x1="470.67"
        y1="99.2858"
        x2="491.911"
        y2="93.5549"
        stroke="white"
        strokeWidth="4"
      />
    </g>
    <defs>
      <filter
        id="filter0_d"
        x="124"
        y="85"
        width="62.3045"
        height="62.3045"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d"
        x="233.22"
        y="140.172"
        width="48.8583"
        height="48.9266"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d"
        x="242.529"
        y="155.922"
        width="24.6193"
        height="38.8065"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
      <filter
        id="filter3_d"
        x="3.21996"
        y="124.172"
        width="48.8583"
        height="48.9266"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
      <filter
        id="filter4_d"
        x="13.1435"
        y="141.546"
        width="27.7869"
        height="33.7031"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
      <filter
        id="filter5_d"
        x="124"
        y="5.69727"
        width="43.0058"
        height="47.8303"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
      <filter
        id="filter6_d"
        x="371"
        y="104.697"
        width="43.0058"
        height="47.8303"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
      <filter
        id="filter7_d"
        x="294"
        y="41.208"
        width="51.3666"
        height="52.2859"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
      <filter
        id="filter8_d"
        x="460.647"
        y="76.792"
        width="41.9326"
        height="42.3242"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
      <filter
        id="filter9_d"
        x="465.667"
        y="94.0283"
        width="37.8625"
        height="30.0139"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
      <filter
        id="filter10_d"
        x="466.149"
        y="91.624"
        width="30.2824"
        height="17.5928"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow"
          result="shape"
        />
      </filter>
      <clipPath id="clip0">
        <rect
          width="42.7604"
          height="42.7604"
          fill="white"
          transform="translate(141.849 85) rotate(18.897)"
        />
      </clipPath>
      <clipPath id="clip1">
        <rect
          width="52"
          height="52"
          fill="white"
          transform="translate(230 136)"
        />
      </clipPath>
      <clipPath id="clip2">
        <rect
          width="52"
          height="52"
          fill="white"
          transform="translate(0 120)"
        />
      </clipPath>
    </defs>
  </svg>
);

const TokodotScattered = () => (
  <svg
    width="351"
    height="226"
    viewBox="0 0 351 226"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.1"
      d="M26.6721 35.3339L21.1385 36.3438L19.7306 28.6304L8.16041 30.7421L9.56824 38.4556L5.45997 39.2054L6.99023 47.5896L11.0985 46.8398L13.7535 61.3864C14.9015 68.151 19.6962 70.8063 27.6019 68.9086C30.1951 68.2836 32.045 67.3829 33.0357 66.8772L29.8745 59.0506C29.4534 59.2357 28.3636 59.6728 27.6719 59.7991C26.1628 60.0745 25.3696 59.5262 25.1248 58.1847L22.6687 44.7281L28.2023 43.7181L26.6721 35.3339ZM52.5417 64.4866C63.022 62.5738 68.0021 54.734 66.1964 44.8407C64.3907 34.9473 56.9622 29.3723 46.4819 31.2851C36.0016 33.1979 31.0215 41.0377 32.8272 50.9311C34.6329 60.8244 42.0614 66.3994 52.5417 64.4866ZM51.0647 55.9194C47.9625 56.4856 45.5556 53.7411 44.6336 48.6896C43.7116 43.6381 44.9938 40.2202 48.096 39.654C51.0305 39.1184 53.4373 41.863 54.3593 46.9145C55.2813 51.966 53.9991 55.3838 51.0647 55.9194Z"
      fill="black"
    />
    <g opacity="0.1">
      <path
        d="M129.961 80.5956L141.272 83.82L143.818 74.8861L146.132 73.2195L149.386 86.1331L162.336 89.8248L156.353 68.9989L170.98 58.2579L158.276 54.6363L147.639 63.0365L147.23 62.9197L153.234 41.8555L141.924 38.6311L129.961 80.5956Z"
        fill="#8A80FF"
      />
      <path
        d="M179.953 95.4672C190.198 98.3878 198.132 93.5599 200.89 83.8883C203.647 74.2168 199.451 65.9309 189.205 63.0103C178.96 60.0897 171.026 64.9176 168.269 74.5891C165.512 84.2606 169.708 92.5466 179.953 95.4672ZM182.418 87.1305C179.385 86.266 178.441 82.7398 179.849 77.8016C181.256 72.8634 183.918 70.3653 186.951 71.2298C189.819 72.0476 190.764 75.5737 189.356 80.5119C187.949 85.4502 185.287 87.9482 182.418 87.1305Z"
        fill="black"
      />
    </g>
    <g opacity="0.1">
      <path
        d="M204.909 186.592C209.366 185.446 211.805 182.267 212.298 178.708L212.546 178.644L213.883 183.845L225.191 180.938L214.327 138.675L202.936 141.604L207.074 157.7L206.909 157.742C204.843 154.841 201.171 152.881 196.466 154.091C190.193 155.703 185.315 162.061 188.265 173.535C191.087 184.513 198.14 188.331 204.909 186.592ZM206.869 176.76C203.733 177.566 201.195 175.226 199.986 170.521C198.776 165.816 199.871 162.543 203.008 161.737C206.144 160.93 208.764 163.249 209.974 167.954C211.162 172.576 210.006 175.953 206.869 176.76ZM246.203 176.152C256.52 173.5 260.931 165.326 258.427 155.586C255.923 145.846 248.118 140.813 237.8 143.465C227.482 146.118 223.071 154.291 225.575 164.031C228.079 173.771 235.885 178.805 246.203 176.152ZM244.121 167.712C241.067 168.497 238.471 165.93 237.192 160.957C235.914 155.984 236.95 152.483 240.004 151.698C242.893 150.956 245.489 153.522 246.767 158.496C248.046 163.469 247.01 166.969 244.121 167.712ZM277.857 133.608L272.409 135.008L270.457 127.414L259.066 130.343L261.018 137.937L256.973 138.976L259.095 147.231L263.14 146.191L266.821 160.512C268.447 167.178 273.418 169.486 281.169 167.032C283.712 166.224 285.493 165.194 286.445 164.619L282.736 157.037C282.329 157.252 281.273 157.765 280.592 157.94C279.106 158.322 278.276 157.832 277.937 156.511L274.531 143.263L279.979 141.862L277.857 133.608Z"
        fill="black"
      />
      <path
        d="M297.014 163.179C300.047 162.399 302.093 159.145 301.307 155.915C300.459 152.789 297.098 150.925 294.064 151.705C290.866 152.527 288.903 155.76 289.75 158.886C290.537 162.116 293.815 164.001 297.014 163.179Z"
        fill="#9492FF"
      />
    </g>
  </svg>
);
const TokodotFlow = () => (
  <svg viewBox="0 0 1440 123" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 46.125L40 35.891C80 25.4648 160 5.28516 240 10.234C320 15.375 400 46.125 480 53.8125C560 61.5 640 46.125 720 35.891C800 25.4648 880 20.6602 960 23.0625C1040 25.4648 1120 36.0352 1200 33.2965C1280 30.75 1360 15.375 1400 7.6875L1440 0V123H1400C1360 123 1280 123 1200 123C1120 123 1040 123 960 123C880 123 800 123 720 123C640 123 560 123 480 123C400 123 320 123 240 123C160 123 80 123 40 123H0V46.125Z"
      fill="#9A93FF"
      fill-opacity="0.4"
    />
  </svg>
);

const Logo = ({ dark: boolean }: { dark?: boolean }) => (
  <svg
    width="179"
    viewBox="0 0 179 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M62.5149 14.6364H59.4361V10.7159H54.8977V14.6364H52.6605V18.0455H54.8977V26.5682C54.8764 29.7749 57.0604 31.3622 60.3523 31.2237C61.5241 31.1811 62.3551 30.9467 62.8132 30.7976L62.0994 27.4205C61.8757 27.4631 61.3963 27.5696 60.9702 27.5696C60.0646 27.5696 59.4361 27.2287 59.4361 25.9716V18.0455H62.5149V14.6364ZM72.6889 31.3196C77.6534 31.3196 80.7429 27.9212 80.7429 22.8821C80.7429 17.8111 77.6534 14.4233 72.6889 14.4233C67.7244 14.4233 64.6349 17.8111 64.6349 22.8821C64.6349 27.9212 67.7244 31.3196 72.6889 31.3196ZM72.7102 27.804C70.4197 27.804 69.2479 25.7053 69.2479 22.8501C69.2479 19.995 70.4197 17.8857 72.7102 17.8857C74.9581 17.8857 76.13 19.995 76.13 22.8501C76.13 25.7053 74.9581 27.804 72.7102 27.804ZM108.548 31.3196C113.513 31.3196 116.602 27.9212 116.602 22.8821C116.602 17.8111 113.513 14.4233 108.548 14.4233C103.584 14.4233 100.494 17.8111 100.494 22.8821C100.494 27.9212 103.584 31.3196 108.548 31.3196ZM108.57 27.804C106.279 27.804 105.107 25.7053 105.107 22.8501C105.107 19.995 106.279 17.8857 108.57 17.8857C110.817 17.8857 111.989 19.995 111.989 22.8501C111.989 25.7053 110.817 27.804 108.57 27.804ZM125.583 31.2663C128.225 31.2663 129.599 29.7429 130.228 28.3793H130.42V31H134.894V9.18182H130.366V17.3849H130.228C129.621 16.0533 128.31 14.4233 125.572 14.4233C121.982 14.4233 118.946 17.2145 118.946 22.8395C118.946 28.3153 121.854 31.2663 125.583 31.2663ZM127.021 27.6548C124.795 27.6548 123.58 25.6733 123.58 22.8182C123.58 19.9844 124.773 18.0348 127.021 18.0348C129.227 18.0348 130.462 19.8991 130.462 22.8182C130.462 25.7372 129.205 27.6548 127.021 27.6548ZM146.019 31.3196C150.983 31.3196 154.073 27.9212 154.073 22.8821C154.073 17.8111 150.983 14.4233 146.019 14.4233C141.055 14.4233 137.965 17.8111 137.965 22.8821C137.965 27.9212 141.055 31.3196 146.019 31.3196ZM146.04 27.804C143.75 27.804 142.578 25.7053 142.578 22.8501C142.578 19.995 143.75 17.8857 146.04 17.8857C148.288 17.8857 149.46 19.995 149.46 22.8501C149.46 25.7053 148.288 27.804 146.04 27.804ZM165.728 14.6364H162.649V10.7159H158.111V14.6364H155.873V18.0455H158.111V26.5682C158.089 29.7749 160.273 31.3622 163.565 31.2237C164.737 31.1811 165.568 30.9467 166.026 30.7976L165.312 27.4205C165.089 27.4631 164.609 27.5696 164.183 27.5696C163.278 27.5696 162.649 27.2287 162.649 25.9716V18.0455H165.728V14.6364Z"
      fill="#000"
    />
    <path
      d="M83.6939 31H88.2322V25.8011L89.4574 24.4055L93.9212 31H99.2372L92.8558 21.7209L98.9283 14.6364H93.7188L88.4773 20.8473H88.2322V9.18182H83.6939V31Z"
      fill="#000"
    />
    <path
      d="M35 27.6629V12.9962C34.9993 12.3532 34.8296 11.7217 34.5078 11.165C34.186 10.6084 33.7235 10.1461 33.1667 9.82457L20.3333 2.49124C19.7759 2.16942 19.1436 2 18.5 2C17.8564 2 17.2241 2.16942 16.6667 2.49124L3.83333 9.82457C3.27648 10.1461 2.81396 10.6084 2.49218 11.165C2.1704 11.7217 2.00066 12.3532 2 12.9962V27.6629C2.00066 28.3059 2.1704 28.9374 2.49218 29.4941C2.81396 30.0508 3.27648 30.5131 3.83333 30.8346L16.6667 38.1679C17.2241 38.4897 17.8564 38.6591 18.5 38.6591C19.1436 38.6591 19.7759 38.4897 20.3333 38.1679L33.1667 30.8346C33.7235 30.5131 34.186 30.0508 34.5078 29.4941C34.8296 28.9374 34.9993 28.3059 35 27.6629Z"
      stroke="#000"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 28L19.0002 15L35 28"
      stroke="#000"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 37L19 16"
      stroke="#000"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
  // <svg
  //   width="179"
  //   height="41"
  //   viewBox="0 0 179 41"
  //   fill="none"
  //   xmlns="http://www.w3.org/2000/svg"
  // >
  //   <path
  //     d="M62.5149 14.6364H59.4361V10.7159H54.8977V14.6364H52.6605V18.0455H54.8977V26.5682C54.8764 29.7749 57.0604 31.3622 60.3523 31.2237C61.5241 31.1811 62.3551 30.9467 62.8132 30.7976L62.0994 27.4205C61.8757 27.4631 61.3963 27.5696 60.9702 27.5696C60.0646 27.5696 59.4361 27.2287 59.4361 25.9716V18.0455H62.5149V14.6364ZM72.6889 31.3196C77.6534 31.3196 80.7429 27.9212 80.7429 22.8821C80.7429 17.8111 77.6534 14.4233 72.6889 14.4233C67.7244 14.4233 64.6349 17.8111 64.6349 22.8821C64.6349 27.9212 67.7244 31.3196 72.6889 31.3196ZM72.7102 27.804C70.4197 27.804 69.2479 25.7053 69.2479 22.8501C69.2479 19.995 70.4197 17.8857 72.7102 17.8857C74.9581 17.8857 76.13 19.995 76.13 22.8501C76.13 25.7053 74.9581 27.804 72.7102 27.804ZM108.548 31.3196C113.513 31.3196 116.602 27.9212 116.602 22.8821C116.602 17.8111 113.513 14.4233 108.548 14.4233C103.584 14.4233 100.494 17.8111 100.494 22.8821C100.494 27.9212 103.584 31.3196 108.548 31.3196ZM108.57 27.804C106.279 27.804 105.107 25.7053 105.107 22.8501C105.107 19.995 106.279 17.8857 108.57 17.8857C110.817 17.8857 111.989 19.995 111.989 22.8501C111.989 25.7053 110.817 27.804 108.57 27.804ZM125.583 31.2663C128.225 31.2663 129.599 29.7429 130.228 28.3793H130.42V31H134.894V9.18182H130.366V17.3849H130.228C129.621 16.0533 128.31 14.4233 125.572 14.4233C121.982 14.4233 118.946 17.2145 118.946 22.8395C118.946 28.3153 121.854 31.2663 125.583 31.2663ZM127.021 27.6548C124.795 27.6548 123.58 25.6733 123.58 22.8182C123.58 19.9844 124.773 18.0348 127.021 18.0348C129.227 18.0348 130.462 19.8991 130.462 22.8182C130.462 25.7372 129.205 27.6548 127.021 27.6548ZM146.019 31.3196C150.983 31.3196 154.073 27.9212 154.073 22.8821C154.073 17.8111 150.983 14.4233 146.019 14.4233C141.055 14.4233 137.965 17.8111 137.965 22.8821C137.965 27.9212 141.055 31.3196 146.019 31.3196ZM146.04 27.804C143.75 27.804 142.578 25.7053 142.578 22.8501C142.578 19.995 143.75 17.8857 146.04 17.8857C148.288 17.8857 149.46 19.995 149.46 22.8501C149.46 25.7053 148.288 27.804 146.04 27.804ZM165.728 14.6364H162.649V10.7159H158.111V14.6364H155.873V18.0455H158.111V26.5682C158.089 29.7749 160.273 31.3622 163.565 31.2237C164.737 31.1811 165.568 30.9467 166.026 30.7976L165.312 27.4205C165.089 27.4631 164.609 27.5696 164.183 27.5696C163.278 27.5696 162.649 27.2287 162.649 25.9716V18.0455H165.728V14.6364Z"
  //     fill="white"
  //   />
  //   <path
  //     d="M83.6939 31H88.2322V25.8011L89.4574 24.4055L93.9212 31H99.2372L92.8558 21.7209L98.9283 14.6364H93.7188L88.4773 20.8473H88.2322V9.18182H83.6939V31Z"
  //     fill="#7167FF"
  //   />
  //   <path
  //     d="M35 27.6629V12.9962C34.9993 12.3532 34.8296 11.7217 34.5078 11.165C34.186 10.6084 33.7235 10.1461 33.1667 9.82457L20.3333 2.49124C19.7759 2.16942 19.1436 2 18.5 2C17.8564 2 17.2241 2.16942 16.6667 2.49124L3.83333 9.82457C3.27648 10.1461 2.81396 10.6084 2.49218 11.165C2.1704 11.7217 2.00066 12.3532 2 12.9962V27.6629C2.00066 28.3059 2.1704 28.9374 2.49218 29.4941C2.81396 30.0508 3.27648 30.5131 3.83333 30.8346L16.6667 38.1679C17.2241 38.4897 17.8564 38.6591 18.5 38.6591C19.1436 38.6591 19.7759 38.4897 20.3333 38.1679L33.1667 30.8346C33.7235 30.5131 34.186 30.0508 34.5078 29.4941C34.8296 28.9374 34.9993 28.3059 35 27.6629Z"
  //     stroke="url(#paint0_linear)"
  //     strokeWidth="4"
  //     strokeLinecap="round"
  //     strokeLinejoin="round"
  //   />
  //   <path
  //     d="M2 28L19.0002 15L35 28"
  //     stroke="#7167FF"
  //     strokeWidth="4"
  //     strokeLinecap="round"
  //     strokeLinejoin="round"
  //   />
  //   <path
  //     d="M19 37L19 16"
  //     stroke="#7167FF"
  //     strokeWidth="4"
  //     strokeLinecap="round"
  //     strokeLinejoin="round"
  //   />
  //   <defs>
  //     <linearGradient
  //       id="paint0_linear"
  //       x1="18.5"
  //       y1="2"
  //       x2="18.5"
  //       y2="38.6591"
  //       gradientUnits="userSpaceOnUse"
  //     >
  //       <stop stopColor="#3C95DA" />
  //       <stop offset="1" stopColor="#6A54DE" />
  //     </linearGradient>
  //   </defs>
  // </svg>
);
export default HomePage;
